module.exports = __webpack_public_path__ + "img/2-preview.fd225edb.jpg";